exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-sidebar {\n  padding: 0px !important;\n  height: 100%; }\n  .nav-sidebar #logo img {\n    width: 100%; }\n\n.app-content {\n  height: 100%;\n  overflow-y: scroll; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = 385
// module chunks = 0